import { Box } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useInlineAsset } from '../context';
import { useTranslation } from 'react-i18next';

const InlineAssetStatus = (props: any) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { isUploading, isFetchingURL } = useInlineAsset();

  if (!isUploading && !isFetchingURL) return null;

  return (
    <Box
      sx={{
        color: theme.palette.info.main,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {isUploading && `${t('blox.actions.uploading')}...${' '}`}
      {isFetchingURL && `${t('blox.actions.fetching')}...${' '}`}
      <CircularProgress
        size={'1rem'}
        sx={{
          color: theme.palette.info.main,
        }}
      />
    </Box>
  );
};

export default InlineAssetStatus;
